import React, { useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import AdminLayoutWrapper from "@components/layout/AdminLayoutWrapper";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import { useRootAppStore } from "@hooks";
import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { AccountStatementContext } from "@state/context/account-statement/AccountStatementContext";
import AccountStatementStore from "@state/stores/account-statement/AccountStatementStore";
import { setTabTitle } from "@utils";
import { observer } from "mobx-react";

import { AccountStatementBody } from "./components/AccountStatementBody";

export default observer(function AccountStatementPage() {
	const rootStore = useRootAppStore();
	const store = useMemo(() => new AccountStatementStore(rootStore), []);

	const { t } = useTranslation();

	useEffect(() => {
		setTabTitle(t("HEADER.ACCOUNT_STATEMENT"));
		if (rootStore?.isSideMenuExpanded != null) {
			rootStore.closeSideMenu();
		}
		store.onInitialize();

		return () => {
			if (rootStore?.isSideMenuExpanded != null) {
				rootStore.openSideMenu();
			}
			store.onDispose();
		};
	}, []);

	useScrollRestoration({
		type: ConfigType.Basic,
		isLoading: store.shouldShowSkeletonLoader,
	});

	return (
		<AdminLayoutWrapper>
			<AccountStatementContext.Provider value={store}>
				<div className="container">
					<AccountStatementBody />
				</div>
			</AccountStatementContext.Provider>
		</AdminLayoutWrapper>
	);
});
